import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, CircularProgress, IconButton,
  Stack
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useDispatch } from 'react-redux';
import { uploadInvestment } from '../../actions/investments';
import { editInversionClient } from '../../actions/users';

const UploadComprobanteModal = ({ open, handleClose, item }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');

  React.useEffect(() => {
    if (!open) {
      setFile(null);
      setError('');
    }
  }, [open]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
      if (!validTypes.includes(selectedFile.type)) {
        setError('El archivo debe ser PDF, JPG o PNG');
        return;
      }
      setError('');
      setFile(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Por favor selecciona un archivo');
      return;
    }

    setLoading(true);
    try {
      const fileName = file.name.split('.').slice(0, -1).join('.');
      const formData = new FormData();
      formData.append('file', file);
      formData.append('carpeta', `inversiones_comprobantes/${item.idUsr}`);
      formData.append('nombre', fileName);

      const res = await dispatch(uploadInvestment(formData));

      if (res) {
        const updateData = {
          status: 0,
          monto: item.monto,
          comprobante: res.secure_url
        };

        await dispatch(editInversionClient(updateData, item.idUsr, item.reference));
        handleClose();
      } else {
        setError('Error al subir el archivo a la nube');
      }
    } catch (err) {
      console.error(err);
      setError('Hubo un error al procesar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">
            Subir Comprobante de Pago
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 2 }}>
          <Stack spacing={3}>
            <Typography variant="body2" >
              Sube tu comprobante de pago (PDF, JPG o PNG)
            </Typography>
            <Box>
              <Button
                variant="outlined"
                component="label"
                fullWidth
                startIcon={file ? <CheckCircleIcon color="success" /> : <UploadFileIcon />}
                sx={{ height: '56px', borderStyle: 'dashed' }}
              >
                {file ? file.name : 'Seleccionar archivo'}
                <input
                  type="file"
                  hidden
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={handleFileChange}
                />
              </Button>
            </Box>

            {error && (
              <Typography color="error" variant="caption">
                {error}
              </Typography>
            )}
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleUpload}
          variant="contained"
          disabled={loading || !file}
          startIcon={loading && <CircularProgress size={20} color="inherit" />}
        >
          {loading ? 'Subiendo...' : 'Subir Comprobante'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadComprobanteModal;
